import { AbstractListController } from "src/app/common/abstract-list.component";
import { Router, ActivatedRoute } from "@angular/router";
import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { Component, ElementRef, inject, viewChild, signal } from "@angular/core";
import { Blog } from '../../models/blog';
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { CategoryService } from '../../services/categories.service';
import { Category } from '../../models/category';
import {MessageService} from 'primeng/api';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { ComuniService } from 'src/app/services/comuni.service';
import { Comuni } from 'src/app/models/comuni';
import { BillingsService } from 'src/app/services/billings.service';
import { jsPDF } from "jspdf";
import { NgxSpinnerService } from "ngx-spinner";
import { Billings } from 'src/app/models/billings';
import { Quotes } from 'src/app/models/quotes';
import { QuotesService } from 'src/app/services/quotes.service';
import { PARAM_BILLINGS_PATH, PARAM_QUOTES_PATH } from '../../constants/constants';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { DatePicker } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';
import { SlicePipe, CurrencyPipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { InitialsAvatarComponent } from '../../components/initials-avatar/initials-avatar.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { Tag } from 'primeng/tag';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';
import { KeysPipe } from '../../pipe/key.pipe';

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-quotes",
    templateUrl: "./manage-quotes.component.html",
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, DatePicker, FormsModule, ButtonDirective, TopNavComponent, RouterLink, Card, TableModule, InitialsAvatarComponent, NgxPaginationModule, Tag, ConfirmDialog, Toast, SlicePipe, CurrencyPipe, TranslatePipe, KeysPipe]
})
export class ManageQuotesComponent extends AbstractListController<Quotes, any> {
  private clientsService = inject(ClientsService);
  private comuniService = inject(ComuniService);

  readonly quote = signal<Quotes>(undefined);
  readonly clients = signal<any>([]);
  readonly comuni = signal<any>([]);
  readonly roomDialog = signal<boolean>(false);
  readonly selectedSkills = signal<any[]>(undefined);
  readonly cols = signal<any[]>(undefined);
  readonly content = viewChild<ElementRef>("content");
  title = "Preventivi";

  constructor() {
    super(inject(QuotesService), inject(ConfirmationService), inject(Router), inject(ActivatedRoute), PARAM_QUOTES_PATH);

    this.cols.set([
      { field: "category_id", header: "Cliente" },
      { field: "id", header: "Numero Fattura" },
    ]);
    this.colsFilter.set([
      { field: "date_gte", icon: "pi-calendar", header: "Dal", type: "date" },
      { field: "date_lte", icon: "pi-calendar", header: "Al", type: "date" },
    ]);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getComuni();
    this.getClients();
  }

  getClients() {
    this.clientsService.getAllListbyUser().subscribe(
      (data: Clients) => this.clients.set(data),
      (error) => this.error.set(error),
    );
  }

  getComuni() {
    this.comuniService.getAllList().subscribe(
      (data: Comuni) => this.comuni.set(data),
      (error) => this.error.set(error),
    );
  }

  getCategoryItem(category_id: string, id: string) {
    return this.clients().find((item) => item.id === category_id);
  }

  getComuniItem(category_id: string, id: string) {
    return this.comuni().find((item) => item.id === category_id);
  }

  edit(quote: Quotes) {
    this.quote.set({ ...quote });
    this.selectedSkills.set(JSON.parse("" + this.quote().skills + ""));
    this.roomDialog.set(true);
  }

  hideDialog() {
    this.roomDialog.set(false);
  }
}
